import { Injectable } from '@angular/core';
import * as faker from 'faker/locale/pt_BR';
import { AreaParticipacao } from '../Models/area-participacao.mode';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AreaParticipacaoService {

  constructor() {
  }

  getAreaParticipacao(areaParticipacaoId: number): Observable<AreaParticipacao> {
    return of(this.mockAreaParticipacao(areaParticipacaoId));
  }

  private mockAreaParticipacao(id: number): AreaParticipacao {
    let area = new AreaParticipacao();
    area.areaparticipacaoid = id
    area.ativo = true;
    area.nome = this.obterNomeAreasParticipacao(id);
    area.descricao = ''; //faker.lorem.lines(4);

    return area;
  }

  private obterNomeAreasParticipacao(id: number): string {
    let nome: string;

    switch (Number(id)) {
      case 1:
        nome = 'Saúde';
        break;
      case 2:
        nome = 'Justiça e Segurança Pública';
        break;
      case 3:
        nome = 'Educação';
        break;
      case 4:
        nome = 'Meio Ambiente';
        break;
      case 5:
        nome = 'Cultura, Esporte e Lazer';
        break;
      case 6:
        nome = 'Infraestrutura';
        break;
      case 7:
        nome = 'Desenvolvimento Econômico';
        break;
      case 8:
        nome = 'Ciência, Tecnologia e Informação';
        break;
      case 9:
        nome = 'Desenvolvimento Humano e Social';
        break;
      case 10:
        nome = 'Gestão Pública';
        break;
      default: 'Não informado'
        break;
    }

    return nome;
  }
}
